/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Available white-labels
 *
 * @returns {Object.<Promise>} default - list of available themes
 * @param {string} [property]          - theme alias
 * @param {string} webpackChunkName    - theme pack
 * @param {string} import(arg)         - path to theme
 *
 */
const themes = {}
const whiteLabels = [
  'docs',
  'default',
  'Apple',
  'Dell'
]

whiteLabels.forEach(key => {
  themes[key] = () => import(/* webpackChunkName: "[request]" */ `./${key}/theme.scss`)
})

export default {
  app     : themes,
  domains : {
    default: 'default',
    // 'alt.dozainer.com': 'Apple',
    'www.dozainer.org': 'Dell'
  }
}



// WEBPACK FOOTER //
// ./src/components/Themes/index.js